import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import EditCalendarPeriodRangeView from 'scoreboard/components/designer/edit-calendar-period-range-view'
import pieLike from 'scoreboard/charts/pie-like'

/**
 * Extends the generic EditCalendarPeriodRangeView component
 * and adds an additional toggle for pie like charts to indicate if multiple
 * charts should be used when there is more than one range.
 */
const ChartsEditCalendarPeriodRangeView = EditCalendarPeriodRangeView.extend(/** @lends ChartsEditCalendarPeriodRangeView.prototype */{

	/**
	 * @override
	 */
	renderRangeSelectors: function() {
		EditCalendarPeriodRangeView.prototype.renderRangeSelectors.apply(this, arguments)

		if (pieLike(this.options.chartDesigner)) {
			this.renderMultipleToggle()
		}
	},

	renderMultipleToggle: function() {
		// #37534 To make sure this displays as a row, we need to manually append
		// the html needed instead of adding it to the template
		const html = `
		<div class="multiple toggler-row">
			<label class="label">
				<span class="label-text">${i18n.get('charts.breakdown.repeating.treatRangeAs')}</span>
			</label>
			<span class="multiple-toggle-container toggle-container toggler-row-content"></span>
		</div>`

		this.$('.toggler-rows').append(html)
		const toggleData = [
			{ label: i18n.get('charts.breakdown.repeating.multipleCharts'), value: 'multiple' },
			{ label: i18n.get('charts.breakdown.repeating.oneChart'), value: 'single' }
		]
		this.toggle = new LabeledToggle({options: toggleData})
		this.$('.multiple-toggle-container').append(this.toggle.el)
		this.toggle.render()
		const value = this.breakdown.get('multipleCharts')
		this.multipleCharts = _.isNil(value) ? true : value
		this.toggle.val(this.multipleCharts ? 'multiple' : 'single', { silent: false })
		this.toggle.on('change', newValue => {
			this.multipleCharts = newValue === 'multiple'
			this.breakdown.set('multipleCharts', this.multipleCharts)
			this.formView.change()
		})
	},

	/**
	 * @override
	 */
	allowUndefinedCalendars () {
		// #49649 we currently only support using undefined calendars for
		// dataset queries, so we can't use them if there is any scorecard
		// or initiative data on the chart
		return !this.options.chartDesigner.hasScorecardItemSources()
			&& !this.options.chartDesigner.hasInitiativeSources()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([ this.toggle ], 'remove')
	}

})

export default ChartsEditCalendarPeriodRangeView

ChartsEditCalendarPeriodRangeView.__filename__ = 'charts/edit/charts-edit-calendar-period-range-view.js'
